import React, { useRef, useState } from 'react';
import { Loader, Dimmer, TableBody, TableCell, TableRow } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';
import CatalogoProductosExistencias from '../../catalogos/catalogoProductosExistencias';
import CatalogoAlmacen from '../../catalogos/catalogoAlmacen';

export const ModalReversarPagos = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));


  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtCodigo = useRef();
  const txtCedula = useRef();
  const txtNumNota = useRef();
  const txtPorProduct = useRef();
  const txtNombreProducto = useRef();
  const txtTodosProduct = useRef();
  const txtTodosAlmacen = useRef();
  const txtPorAlmacen = useRef();
  const txtNombreAlmacen = useRef();
  const txtCodigoAlmacen = useRef();
  const txtNombre = useRef();
  const txtRif = useRef();
  const txtCbmrif = useRef();

  const [inputalmacen, setInputalmacen] = useState('');
  const [valalmacen, setValalmacen] = useState(null);
  const [valproducto, setValproducto] = useState(null);
  const [inputproducto, setInputproducto] = useState(0);
  const [fechare, setFechare] = useState(null);
  const [mostrar1, setMostrar1] = useState(null);
  const [mostrar2, setMostrar2] = useState(null);
  const [parafecha, setParafecha] = useState('');
  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');
  const [disponiblec, setDisponiblec] = useState('');
  const [numnota, setNumNota] = useState('');
  const [idclient, setIdclient] = useState('');
  const [vinpurt, setVinput] = useState(true);
  const [mostrarClavesup, setMostrarClavesup] = useState(false);
  const [valida2, setValida2] = useState(0);
  const [activate, setActivate] = useState(false);
  const [idproduct, setIdproduct] = useState('');
  const [estatus, setEstatus] = useState('');
  const [valida, setValida] = useState(0);
  const [body, setBody] = useState(null);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [tituid, setTituid] = useState('');
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false
  });


  const blanquear = () => {
    setActivate(false);
    setBody(null);
    setInputalmacen('');
    setParafecha('');
    setDisponiblec('');
    setNumNota('');
    setInputproducto(0);
    setValida(0);
    setValida2(0);
    setIdclient('');
    setIdproduct('');
    setVinput(true);
    setMostrar1(false);
    setMostrar2(false);
    setEstatus("");
    setDesde('');
    setHasta('');
    setValalmacen(0);
    setValproducto(0);
    setFechare(null);
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancela();

  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    let sigue = true;
    if (props.ope === 3) {

      if (txtNumNota.current.value === '') {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Introduzca el Número de Recibo !",
          icono: "informacion",
        });
        sigue = false;
        txtNumNota.current.focus();
      }

      if (sigue === true) {
        let numReci = txtNumNota.current.value;
        seleccionarNota(numReci);
      }

    }

  }

  const seleccionarNota = (numreci) => {
    const campos = "(select p.numpedido from pedido p where p.numpedido = (select n.numpedido from notaentrega n where n.numnotaentrega = numfactura)) as numpedidos, fecharegistro as fecha, numfactura, numpago, idpago, statusreverso";
    const nomtab = "registropago";
    const endpoint = `${op.conexion
      }/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=numfactura&id=${numreci.trim().toUpperCase()}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            if (parseInt(response.data.statusreverso) <= 0 || response.data.statusreverso === null) {
              setBody({
                notaentre: [],
                notaentredet: [],
                pagos: [],
                pagosdeta: [],
                app: false,
                ncaja: [],
                fecharev: fechare,
                fechapag: response.data.fecha,
                nidcaja: parseInt(response.data.idpago),
                idusu: parseInt(props.idusuario),
                post: true,
                motivo: "REVERSO DE PAGO - NUMERO DE RECIBO N°: " + response.data.numpago +
                  " DE LA NOTA DE ENTREGA N°: " + response.data.numfactura + " DEL PEDIDO N°: " + response.data.numpedidos
              });
              let msg = "¿Esta Seguro de Reversar este Pago?.";
              setMensajesino({
                mostrar: true,
                titulo: "Confirmación.",
                texto: msg,
                icono: "confirmacion",
              });
            } else {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "¡ N° Recibo y/o Pago ya fue Reversado !.",
                icono: "informacion",
              });
              txtNumNota.current.value = '';
              txtNumNota.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "¡ N° Recibo no Existe !.",
              icono: "informacion",
            });
            txtNumNota.current.value = '';
            txtNumNota.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };


  const procesarRegistroNota = (opera) => {
    let endpoint = `${op.conexion}/api/inventario/actualizarpostventas/${opera}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (opera !== 4) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "¡ Pago Reversado Correctamente !",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = error.response.data.message;
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    procesarRegistroNota(props.ope);
  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
    props.onHideCancela();
    props.onCerrar();
  }

  const onChange = (e) => {

    if (e.target.name === 'numnota') {
      if (e.target.value !== '') {
        setVinput(false);
      }
    }

  }

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "numnota") {
          btnAcepta.current.focus();
        }
      }
    }
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        if (props.ope === 3) {
          let fecha = moment(fechasistema).format('DD/MM/YYYY');
          setFechare(fecha);
          txtNumNota.current.focus();
        }


      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>REVERSAR PAGO</h3></div>

        <a href='#' ref={btnSalir} disabled={botones.salir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0 m-0'>

          <div className='col-12 row m-0 px-0 py-2'>

            <fieldset className='row col-sm-12 mx-auto mb-1 px-0'>

              <div className='col'>
                <div className="input-group input-group-sm mb-2">
                  <label className="input-group-text" id="inputGroup-sizing-sm">NUMERO DE RECIBO: </label>
                  <input autoComplete='off' type='text' name="numnota" ref={txtNumNota} onChange={onChange} onKeyUp={handleInputNumeroChange} className="form-control bg-transparent fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

            </fieldset>

          </div>

        </div>


      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">
          <div className='col-md-11 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnAcepta} disabled={vinpurt} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-success mx-1"><i className="fas fa-check-circle">  Aceptar</i></button>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>
      {/* <CatalogoAlmacen
        show={mostrar2}
        onHideCancelar={() => setMostrar2(false)}
        onHideAceptaCatalogo={handleAceptaAlmacen}
      /> */}
    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/ventas/modalReversarPago.js